'use strict';

var mailTemplateModule = angular.module('t2g.mailTemplate', [
  'gettext',
  'ui.router',
  require('t2g.common.services.notificationService').name,
]);

module.exports = mailTemplateModule;

mailTemplateModule.controller('MailTemplateCtrl', require('./MailTemplateCtrl'));
mailTemplateModule.controller('MailTemplateDetailCtrl', require('./MailTemplateDetailCtrl'));

mailTemplateModule.config(function($stateProvider) {
  $stateProvider
    .state('private.main.mailTemplate', {
      url: '/mail-template',
      title: 'E-Mail Templates',
      templateUrl: '/app/modules/mailTemplate/MailTemplateView.html?v=4.5.6',
      controller: 'MailTemplateCtrl as MailTemplateCtrl',
    })
    .state('private.main.mailTemplate.detail', {
      url: '/:templateName',
      title: 'E-Mail Templates',
      templateUrl: '/app/modules/mailTemplate/MailTemplateDetailView.html?v=4.5.6',
      controller: 'MailTemplateDetailCtrl as MailTemplateDetailCtrl',
      resolve: {
        template: function($stateParams, MailDA) {
          return MailDA.get($stateParams.templateName);
        },
        placeholder: function($stateParams, placeholderSettings) {
          return placeholderSettings[$stateParams.templateName];
        },
      },
    });
});



// WEBPACK FOOTER //
// ./src/app/modules/mailTemplate/mailTemplateModule.js